// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"690d8b05","453":"32cd05d1","455":"68709d2b","857":"9397aaf2","977":"b8e1714e"}[chunkId] + ".chunk.js";
};